import { audioType } from 'holdem/interfaces'

export default function handleLeftActions(
  audio: audioType,
  gameState: number,
  handleUndo: () => void,
  handleFold: () => void,
  handleDealOut: (b: boolean) => void,
  handleNewBet: () => void,
  setIsClickable: (b: boolean) => void,
  handleActive: (s: string) => void,
  playUndoSFX: () => void,
  playFoldlSFX: () => void,
  playnewBetSFX: () => void,
  handleClearCards: (n: number) => void,
  handleIsFolded: (b: boolean) => void,
) {
  if (gameState === 0) {
    handleUndo()
    audio?.sound && playUndoSFX()
  } else if (gameState === 4) {
    setIsClickable(true)
    handleFold()
    handleIsFolded(true)
    handleDealOut(true)
    handleClearCards(1000)
    audio?.sound && playFoldlSFX()
  } else {
    setIsClickable(true)
    handleNewBet()
    handleDealOut(true)
    handleClearCards(1000)
    handleActive('ante')
    audio?.sound && playnewBetSFX()
  }
}
